import React from 'react';

/**
 * FilterBar (Epic 4, S4.1) — make/model/year/price/mileage/location
 * facets. Controlled, presentation-only: emits filter changes; Epic 7
 * wires these to the discovery query.
 */
export interface VehicleFilters {
  make?: string;
  model?: string;
  year?: string;
  maxPrice?: string;
  maxMileage?: string;
  region?: string;
}

export interface FilterBarProps {
  value?: VehicleFilters;
  onChange?: (next: VehicleFilters) => void;
}

const FIELDS: { key: keyof VehicleFilters; label: string; type: 'text' | 'number' }[] = [
  { key: 'make', label: 'Marca', type: 'text' },
  { key: 'model', label: 'Modelo', type: 'text' },
  { key: 'year', label: 'Año', type: 'number' },
  { key: 'maxPrice', label: 'Precio máx.', type: 'number' },
  { key: 'maxMileage', label: 'Km máx.', type: 'number' },
  { key: 'region', label: 'Ubicación', type: 'text' },
];

export const FilterBar: React.FC<FilterBarProps> = ({ value = {}, onChange }) => (
  <form className="caria-filterbar" data-testid="filter-bar" onSubmit={(e) => e.preventDefault()}>
    {FIELDS.map((f) => (
      <div className="caria-filterbar__field" key={f.key}>
        <label htmlFor={`filter-${f.key}`}>{f.label}</label>
        <input
          id={`filter-${f.key}`}
          type={f.type}
          value={value[f.key] ?? ''}
          onChange={(e) => onChange?.({ ...value, [f.key]: e.target.value })}
        />
      </div>
    ))}
  </form>
);

export default FilterBar;
